import { Component, effect, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Prototype } from '@xanadu/model';
import { PickerComponent } from '../picker/picker.component';
import { PrototypeCache } from '@xanadu/cache';

@Component({
    selector: 'app-prototype-picker',
    templateUrl: './prototype-picker.component.html',
    styleUrls: ['./prototype-picker.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrototypePickerComponent extends PickerComponent<Prototype> {
    private readonly prototypeCache = inject(PrototypeCache);

    exclusives = input<string[]>();

    constructor(
    ) {
        super();

        effect(() => {
            const prototypes = this.prototypeCache.signal();

            if (prototypes) {
                this.items.set([...prototypes.values()]);
            }
        });

        effect(() => {
            const model = this.model();
            const meta = this.meta();

            if (model && meta) {
                meta.readonly = true;
            }
        });
    }

    protected onDelete(index: any): void {
        super.onDelete(index);
        const meta = this.meta();
        if (meta) {
            meta.readonly = false;
        }
    }

    public onPick($event: MatAutocompleteSelectedEvent): void {
        super.onPick($event);
        this.meta().readonly = true;
    }

    protected filter(prototype: Prototype): boolean {
        const exclusives = this.exclusives();
        return !exclusives || !exclusives.find(x => x === prototype._id);
    }
}
